export const SPECIAL_VALUES = {
  noMilestoneData: {
    id: 'no-milestone',
    title: 'No milestone',
    closed: false,
  },
  noLabelsData: {
    id: 'no-labels',
    name: 'No labels',
    color: 'ededed',
    description: 'Issues with no labels',
  },
  noAssigneeData: {
    id: 'no-assignee',
    login: 'No Assignee',
    avatarUrl: '',
  },
}
